import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { isMobile } from "react-device-detect";
import { t } from '../../../../i18n';

interface TournamentRegisterButtonProps {
    canRegisterNow: boolean;
    canUnregister: boolean | undefined;
    hasSpace: boolean;
    cashAllowed: boolean;
    showTicketButton: boolean;
    showTicketDisabled: boolean;
    isUserRegistered: boolean | undefined;
    actionCooldown: boolean;
    handleRegisterClick: () => void;
    handleRegisterWithTicket: () => void;
    handleUnregisterClick: () => void;
}

const TournamentRegisterButton: React.FC<TournamentRegisterButtonProps> = ({
    canRegisterNow,
    canUnregister,
    hasSpace,
    cashAllowed,
    showTicketButton,
    showTicketDisabled,
    isUserRegistered,
    actionCooldown,
    handleRegisterClick,
    handleRegisterWithTicket,
    handleUnregisterClick,
}) => {
    return (
        <>
            {canUnregister && (
                <Box style={{ width: isMobile ? '50%' : '100%', marginTop: isMobile ? 'initial' : 'auto'}}>
                    <Button
                        variant="contained"
                        style={{ color: 'white', textTransform: 'capitalize', fontWeight: 700, fontSize: '16px' }}
                        sx={{ mt: 'auto' }}
                        disabled={actionCooldown}
                        onClick={handleUnregisterClick}
                        fullWidth
                    >
                        {t('Tournament:actions.unregister')}
                    </Button>
                </Box>
            )}
            {canRegisterNow && !isUserRegistered && (
                <Box style={{ width: isMobile ? '50%' : '100%', marginTop: isMobile ? 'initial' : 'auto'}}>
                    {hasSpace ? (
                        <Stack spacing={1}>
                            {cashAllowed && (
                                <Button
                                    variant="contained"
                                    style={{ color: 'white', textTransform: 'capitalize', fontWeight: 700, fontSize: '16px' }}
                                    sx={{ mt: 'auto' }}
                                    disabled={actionCooldown}
                                    onClick={handleRegisterClick}
                                    fullWidth
                                >
                                    {t('Tournament:actions.register')}
                                </Button>
                            )}
                            {showTicketButton && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ color: 'white', textTransform: 'capitalize', fontWeight: 700, fontSize: '16px' }}
                                    sx={{ mt: cashAllowed ? 0 : 'auto' }}
                                    disabled={actionCooldown}
                                    onClick={handleRegisterWithTicket}
                                    fullWidth
                                >
                                    Register with ticket
                                </Button>
                            )}
                            {showTicketDisabled && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled
                                    style={{ textTransform: 'capitalize', fontWeight: 700, fontSize: '16px' }}
                                    fullWidth
                                >
                                    Ticket required
                                </Button>
                            )}
                        </Stack>
                    ) : (
                        <Box sx={{
                            textAlign: 'center',
                            p: 1,
                            backgroundColor: 'rgba(255, 158, 128, 0.1)',
                            borderRadius: '4px',
                            border: '1px solid rgba(255, 158, 128, 0.3)'
                        }}>
                            <Typography variant="body2" sx={{ color: '#ff9e80', fontWeight: 'bold', fontSize: '0.8rem' }}>
                                Tournament is full
                            </Typography>
                        </Box>
                    )}
                </Box>
            )}
        </>
    );
};

export default TournamentRegisterButton;
